import './Chart.LineBar';
import _ from 'lodash';
// import vars from 'react-chartjs/lib/core';
import vars from './core.jsx';

const LineBar = vars.createClass('LineBar', ['getPointsAtEvent','getBarsAtEvent']);

export default LineBar;